import {
    map,
    distinctUntilChanged,
    filter,
} from 'rxjs/operators';

const createTokenUpdate = configUpdate$ =>
    configUpdate$
        .pipe(
            filter(latestConfig => latestConfig.environment.personalisationEnabled),
            map(latestConfig => latestConfig.environment.authToken),
            filter(Boolean),
            distinctUntilChanged(),
        );

export default createTokenUpdate;
